// === STATS ===
export const STATS_TICKET_CREATED_REQUEST = "request stats tickets created";
export const STATS_TICKET_CREATED_SUCCESS =
  "request stats tickets created success";

export function statsTicketCreatedPostSuccess(stats) {
  return { type: STATS_TICKET_CREATED_SUCCESS, stats: stats };
}

// === STATS ===
export const SET_COMPANIES_INFO = "set companies info";
export function setCompaniesInfo(payload) {
  return { type: SET_COMPANIES_INFO, payload: payload };
}
export const SET_COMPANY_INFO = "set company info";
export function setCompanyInfo(company) {
  return { type: SET_COMPANY_INFO, company };
}
export const DELETE_COMPANY = "delete company";
export function deleteCompany(companyId) {
  return { type: DELETE_COMPANY, companyId };
}



// WEBPACK FOOTER //
// src/model/Company/actions.js